// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import authFetch from '../api';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  console.log('🚀 AuthProvider component initializing');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCurrentUser = async () => {
    console.log('🚀 AuthContext: fetchCurrentUser called');
    setLoading(true);
    try {
      const token = localStorage.getItem('jwtToken');
      console.log('🔍 AuthContext: Token exists:', !!token);
      console.log('🔍 AuthContext: Token value:', token ? `${token.substring(0, 20)}...` : 'null');
      
      if (!token) {
        console.log('🔍 AuthContext: No token, setting user to null');
        setUser(null);
        setLoading(false);
        return;
      }
      
      // Fetch real user data from API
      console.log('🔍 AuthContext: Fetching real user data from API...');
      try {
        const userData = await authFetch('/users/me');
        console.log('🔍 AuthContext: Raw API response:', userData);
        console.log('🔍 AuthContext: User role:', userData?.role);
        console.log('🔍 AuthContext: Effective permissions:', userData?.effectivePermissions);
        console.log('🔍 AuthContext: Access permissions:', userData?.access);
        
        // Ensure we're setting the actual user data, not an Axios response
        const actualUserData = userData?.data || userData;
        console.log('🔍 AuthContext: Actual user data to set:', actualUserData);
        console.log('🔍 AuthContext: actualUserData.effectivePermissions:', actualUserData?.effectivePermissions);
        console.log('🔍 AuthContext: actualUserData.access:', actualUserData?.access);
        console.log('🔍 AuthContext: actualUserData.role:', actualUserData?.role);
        setUser(actualUserData);
        console.log('🚀 AuthContext: User set successfully');
      } catch (apiError) {
        console.error('🔍 AuthContext: Failed to fetch user data:', apiError);
        setUser(null);
      }
    } catch (err) {
      console.error('🔍 AuthContext: Error loading current user:', err);
      setUser(null);
    }
    setLoading(false);
    console.log('🚀 AuthContext: fetchCurrentUser completed');
  };

  useEffect(() => {
    console.log('🚀 AuthProvider useEffect called');
    fetchCurrentUser();
  }, []);

  const login = async (userData) => {
    if (userData.token) {
      localStorage.setItem('jwtToken', userData.token);
    }
    await fetchCurrentUser();
  };

  const logout = () => {
    localStorage.removeItem('jwtToken');
    setUser(null);
  };

  const isReadOnly = () => {
    if (!user || typeof user !== 'object') {
      return false;
    }
    // Use effectivePermissions if available, fallback to access
    const permissions = user.effectivePermissions || user.access;
    return !!permissions?.readOnly;
  };

  const refreshUser = fetchCurrentUser;

  console.log('🚀 AuthProvider rendering with user:', user, 'loading:', loading);
  
  return (
    <AuthContext.Provider value={{ user, login, logout, isReadOnly, refreshUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider };

const useAuth = () => React.useContext(AuthContext);
export { useAuth };
export default useAuth;